module.exports = __webpack_public_path__ + "static/media/gigabyte.7c121b2a.svg";